import { User } from "@/interfaces/user";
import { Callback } from "@/types/types";
import cloneDeep from "lodash/cloneDeep";
import debounce from "lodash/debounce";
import find from "lodash/find";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { UsersForm } from "../declarations";
import Template from "./users.template.vue";
const namespace: string = "UserModule";
@Component({
  mixins: [Template]
})
export class UsersComponent extends Vue {
  @Getter("users", { namespace }) public storeUsers!: User[];
  @Getter("loading", { namespace }) public usersLoading!: boolean;
  @Action("searchUsers", { namespace }) public searchUserAction!: Callback;
  @Prop({ required: true }) public value!: UsersForm;
  @Prop({ default: [] }) public dataBaseUsers!: User[];
  @Prop({ default: false }) public loading: boolean = false;
  public search: string | null = null;
  public selection: object | null = null;
  private usersSelected: User[] = [];
  private searchUsers = debounce((value: string) => {
    this.searchUserAction(value);
  }, 500);
  constructor() {
    super();
  }

  @Watch("search")
  public async searchData() {
    if ((!this.selection && this.search) || !this.search) {
      await this.searchUsers(this.search!);
    } else {
      this.deselect();
    }
  }

  public goToStep(step: number) {
    this.$emit("goToStep", step);
  }
  public finish() {
    this.$emit("input", {
      users: this.usersSelected
    });
    this.$emit("finish");
  }

  public deselect() {
    this.selection = this.search = null;
  }

  public itemText(item: User) {
    return `${item.first_name} ${item.last_name} ${
      item.email ? "(" + item.email + ")" : ""
    }`;
  }

  public addUserAction(user: User) {
    const userSearch: User | undefined = this.usersSelected.find(
      userItem => user.id === userItem.id
    );
    this.deselect();
    if (find(this.dataBaseUsers, ["id", user.id!])) {
      this.usersSelected = this.usersSelected.map(userItem => {
        return userItem.id === user.id ? { ...user, delete: false } : userItem;
      });
    }
    if (!userSearch) {
      this.usersSelected.push(user);
    }
    this.$emit("input", { users: this.usersSelected });
  }

  public deleteUserAction(user: User) {
    const userSearch: User | undefined = this.usersSelected.find(
      userItem => user.id === userItem.id
    );
    this.deselect();
    if (userSearch) {
      if (find(this.dataBaseUsers, ["id", userSearch.id!])) {
        this.usersSelected = this.usersSelected.map(userItem => {
          return userItem.id === userSearch.id
            ? { ...userSearch, delete: true }
            : userItem;
        });
      } else {
        this.usersSelected = this.usersSelected.filter(
          userItem => userItem.id !== user.id
        );
      }
    }
  }

  public undoDelete(user: User) {
    user.delete = false;
  }

  public imgError(user: User) {
    user.avatar_thumb_url = "";
  }

  protected created() {
    this.searchUserAction("");
    this.$watch("value.users", () => {
      this.usersSelected = cloneDeep(this.value.users);
    });
  }
}
